export default __webpack_public_path__ + "static/media/330_dummy2016-kunsthandwerk01-de.e941bdc2.png";